import React from "react";
import "./CancellationPolicy.css";
import { useNavigate } from "react-router-dom";

const CancellationPolicy = () => {
     const navigate = useNavigate();
          const handleAgree = () => {
    navigate(-1); // 👈 goes back to previous route
  };
  return (
    <div className="jayraj-policy-page">
      {/* Floating gradient blobs */}
      <div className="jayraj-blob jayraj-blob-pink"></div>
      <div className="jayraj-blob jayraj-blob-blue"></div>

      {/* Card Container */}
      <div className="jayraj-card">
        <h1 className="jayraj-title">Jayraj Group</h1>
        <h2 className="jayraj-subtitle">
          ✨ Cancellation & Property Booking Policy ✨
        </h2>

        <p>
          Welcome to <strong>Jayraj Group</strong>. This policy explains our
          terms regarding property reservations, payments, cancellations, and
          refunds for all bookings made through our platform.
        </p>

        <h3>1. Property Booking Confirmation</h3>
        <p>
          Bookings are confirmed after successful payment and receipt of a
          confirmation message. Please verify all guest and date details before
          finalizing your booking.
        </p>

        <h3>2. Payment Policy</h3>
        <p>
          An advance payment is required when booking. The remaining balance
          must be paid as per the property's check-in policy. Payments are
          processed securely.
        </p>

        <h3>3. Cancellation Policy</h3>
        <p>
          Cancellations within 48 hours of booking are fully refundable unless
          the stay date is within 7 days. Late cancellations may incur up to
          100% charges.
        </p>

        <h3>4. Refunds</h3>
        <p>
          Refunds (if applicable) are processed within 7–10 business days to the
          original payment method. Transaction and gateway fees are
          non-refundable.
        </p>

        <h3>5. No-Show Policy</h3>
        <p>
          Guests who fail to arrive on the scheduled date without notice are
          considered 'no-shows' and will not be eligible for any refund.
        </p>

        <h3>6. Modification of Booking</h3>
        <p>
          Booking changes depend on availability and may include extra charges.
          Requests must be made at least 72 hours before check-in.
        </p>

        <h3>7. Property Rules & Responsibilities</h3>
        <p>
          Guests must follow all property rules. Jayraj Group is not responsible
          for issues caused by rule violations or guest negligence.
        </p>

        <h3>8. Force Majeure</h3>
        <p>
          In cases like natural disasters or government restrictions, Jayraj
          Group reserves the right to modify or cancel bookings without penalty.
        </p>

        <h3>9. Contact Us</h3>
        <p>
          For booking or cancellation support, contact us at{" "}
          <a href="mailto:support@jayrajgroup.com" className="jayraj-link">
            support@jayrajgroup.com
          </a>
          .
        </p>

        <div className="jayraj-button-container">
          <button className="jayraj-btn"  onClick={handleAgree}>I Understand & Accept</button>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;
